import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})

export class HeaderComponent implements OnInit {
  isVisible = false;
  public gmplogoimg!: string;

  ngOnInit(): void {
    if (window.location.href.includes("view")) {
      this.isVisible = true;
    }
    this.gmplogoimg = this.activateImages();
  }

  constructor(public translate: TranslateService) {
    translate.addLangs(['English', 'French']);
    translate.setDefaultLang('English');
  }

  public activateImages() {
    if (document.documentElement.lang == "French") {
      this.gmplogoimg = "/assets/images/gmProtectionsLogo_French.jpg";
    } else {
      this.gmplogoimg = "/assets/images/gmProtectionsLogo.jpg";
    }
    return this.gmplogoimg;
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    document.documentElement.lang = lang;
    this.activateImages();
  }
}
